"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = BulkEditUsers;

var _BulkEditUsers = require("@adobe/react-spectrum-workflow/dist/BulkEditUsers");

var _icon = require("@react-spectrum/icon");

var _react = _interopRequireDefault(require("react"));

function BulkEditUsers(props) {
  return /*#__PURE__*/_react.default.createElement(_icon.Icon, props, /*#__PURE__*/_react.default.createElement(_BulkEditUsers.A4uBulkEditUsers, null));
}